import { Dispatch } from 'redux';

import sendUserBcError, { IUserBcErrorRequestData } from '../../../../../api/user_bc_error';
import { createActionCreator } from '../../../../../utils/fsa';
import { waitAtLeast } from '../../../../../utils/superagent';

export const formSent =
  createActionCreator<{}>('object_form_error/form_sent');

export const formError =
createActionCreator<{ error: Error }>('object_form_error/form_error');

export const setFormData =
  createActionCreator<{ businessShoppingCenterId: number }>('object_form_error/set_from_data');

export function submitForm(
  dispatch: Dispatch<IUserBcErrorRequestData>, data: IUserBcErrorRequestData
): Promise<object> {
  return waitAtLeast(500, sendUserBcError({
    businessShoppingCenterId: data.businessShoppingCenterId,
    message: data.message,
    email: data.email,
  }))
    .then((res) => dispatch(formSent({})))
    .catch((err) => dispatch(formError(err)));
}



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_center_detail/components/object_error_form/action_creators/object_error_form_actions.ts